
export default function Features() {
  const features = [
    {
      icon: 'ri-lock-line',
      title: 'Enhanced Security',
      description: 'Military-grade encryption protecting your data and privacy across all our applications'
    },
    {
      icon: 'ri-dashboard-line',
      title: 'Intuitive Interface',
      description: 'Clean, modern design that makes complex features simple and accessible for everyone'
    },
    {
      icon: 'ri-rocket-line',
      title: 'High Performance',
      description: 'Optimized code ensuring smooth operation without draining your device battery'
    },
    {
      icon: 'ri-refresh-line',
      title: 'Regular Updates',
      description: 'Continuous improvements and new features based on user feedback and latest iOS capabilities'
    },
    {
      icon: 'ri-customer-service-line',
      title: 'Expert Support',
      description: 'Dedicated team ready to assist you with any questions or technical issues'
    },
    {
      icon: 'ri-global-line',
      title: 'Global Reach',
      description: 'Available worldwide with support for multiple languages and regional requirements'
    }
  ];

  return (
    <section id="features" className="py-32 bg-gray-50">
      <div className="max-w-7xl mx-auto px-8">
        <div className="text-center mb-20">
          <h2 className="text-6xl font-light text-gray-900 mb-6">Why Choose Our Apps</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto font-light">
            Discover the features that make our applications stand out in the App Store
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-3xl p-8 transition-all hover:shadow-xl hover:-translate-y-1 cursor-pointer border border-gray-100"
            >
              <div className="w-16 h-16 bg-blue-500 rounded-2xl flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-normal text-gray-900 mb-4">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed font-light">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}